import { type RefObject, useCallback } from 'react'

const HALF_WIDTH = 2

export type ScrollToElement = (
  elementToScroll: RefObject<HTMLElement | null>,
) => void

export const useScrollElementIntoView = (
  scrollableElement: RefObject<HTMLElement | null>,
): ScrollToElement => {
  return useCallback(
    (elementToScroll) => {
      if (!scrollableElement.current || !elementToScroll.current) {
        return
      }

      scrollableElement.current.scrollTo({
        behavior: 'smooth',
        left:
          elementToScroll.current.getBoundingClientRect().left -
          (scrollableElement.current.clientWidth -
            elementToScroll.current.clientWidth) /
            HALF_WIDTH,
        top: 0,
      })
    },
    [scrollableElement],
  )
}
